<div *ngIf="zeigeFehlerMeldung" class="sanduhr">
	<div class="Fehlermeldung">
		<div class="Ueberschrift">{{FehlerUeberschrift}}</div>
		<div class="Hinweis">{{FehlerHinweis}}</div>
		<div class="Bestaetigen">
			<button (click)="fehlerBestaetigt()">OK</button>
		</div>
	</div>
</div>